import React from 'react'
import { Parallax } from 'react-parallax'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, mobileAbout } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobileAbout} w="100%" alt="Ma Dang Goul Korean About" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="550px"
          w="100%"
          image={`url(${about}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
          zIndex={90}
          column
          justifyBetween
          alignCenter
        ></CFView>
      </DefaultScreen>
    </CFView>
  )
}
